import { createTheme } from '@mui/material/styles';
import { getPaperMode, getAccentColor } from './themePresets';

export const getTheme = (paperMode = 'light', accentColor = 'blue') => {
    // Also support passing boolean isDarkMode for backward compatibility
    let currentPaper = typeof paperMode === 'boolean'
        ? getPaperMode(paperMode ? 'dark' : 'light')
        : getPaperMode(paperMode);
    const currentAccent = getAccentColor(accentColor);
    const isDark = currentPaper.isDark;

    return createTheme({
        palette: {
            mode: isDark ? 'dark' : 'light',
            primary: {
                main: isDark ? currentAccent.mainDark : currentAccent.mainLight,
            },
            secondary: {
                main: '#dc004e',
            },
            background: {
                default: currentPaper.bgDefault,
                paper: currentPaper.bgPaper,
            },
            text: {
                primary: currentPaper.textPrimary,
                secondary: currentPaper.textSecondary,
            },
            divider: currentPaper.divider,
        },
        typography: {
            fontFamily: [
                '-apple-system',
                'BlinkMacSystemFont',
                '"Segoe UI"',
                'Roboto',
                '"Helvetica Neue"',
                'Arial',
                'sans-serif',
                '"Apple Color Emoji"',
                '"Segoe UI Emoji"',
                '"Segoe UI Symbol"',
            ].join(','),
        },
        components: {
            MuiListItem: {
                styleOverrides: {
                    root: {
                        '&:hover': {
                            backgroundColor: isDark ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.04)',
                        },
                    },
                },
            },
            MuiLink: {
                styleOverrides: {
                    root: {
                        color: isDark ? 'rgba(255, 255, 255, 0.9)' : 'rgba(0, 0, 0, 0.9)',
                        textDecoration: 'none',
                        transition: 'color 0.2s',
                        '&:hover': {
                            color: isDark ? '#ffffff' : '#000000',
                            textDecoration: 'none',
                        },
                    },
                },
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        textTransform: 'none',
                    },
                },
            },
        },
    });
};
 